import React, { SetStateAction, useContext, useEffect } from "react";
import { useState } from "react";

import { Box, Stack, TableCell, TableRow } from "@mui/material";

import { StyledTableCell, StyledTableHead } from "../../../Styles/tabelCellStyled/customTableCell";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import BasicPopover from "../../../Components/Popover";
import { CustomTextField } from "../../../Styles/theme/customThemeprovider";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { IPage5ADesdobramento } from "../../../Interfaces/cadernos/caderno5/interfaces5A";
import { del, get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { desformatarNumero_return_null, formatarNumero_ao_digitar, desformatarNumero } from "../../../Func_genericas/formatar_numero_formato_pt";
import { formatar_numeros_tabelaExtra_5A } from "../../../Componentes_modulo/FuncoesFormatarNumeroPT/cadernos/caderno5A";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";
import { useLocation } from "react-router-dom";

interface OperacaoFertilizacaoProps {
  extraRow: IPage5ADesdobramento | undefined;
  extraRows: IPage5ADesdobramento[];
  setExtraRows: React.Dispatch<SetStateAction<IPage5ADesdobramento[]>>
  setExtraRow: React.Dispatch<SetStateAction<IPage5ADesdobramento | undefined>>
  idCabecalho: number;
  setOpenSnackSuccess: React.Dispatch<SetStateAction<boolean>>
  setOpenSnackError: React.Dispatch<SetStateAction<boolean>>
  setIsLoading: React.Dispatch<SetStateAction<boolean>>
  setMessage: React.Dispatch<SetStateAction<string>>
}

export const OperacaoFertilizacaoExtra: React.FC<OperacaoFertilizacaoProps> = ({
  extraRow,
  extraRows,
  setExtraRow,
  setExtraRows,
  idCabecalho,
  setOpenSnackSuccess,
  setOpenSnackError,
  setIsLoading,
  setMessage
}) => {
  const auth = useContext(AuthContext);

  const location = useLocation();
  const is_historico = location.state?.is_historico ?? false;

  const [createTable, setCreateTable] = useState(false);
  const [openDeleteExtra, setOpenDeleteExtra] = React.useState(false);


  const [elementos_forn_solo_n, set_error_elementos_forn_solo_n] = useState<boolean>(false);
  const [elementos_forn_agua_n, set_error_elementos_forn_agua_n] = useState<boolean>(false);
  const [totais_aplicados_zona_n, set_error_totais_aplicados_zona_n] = useState<boolean>(false);
  const [totais_aplicados_hectare_n, set_error_totais_aplicados_hectare_n] = useState<boolean>(false);
  const [elementos_forn_solo_po, set_error_elementos_forn_solo_po] = useState<boolean>(false);
  const [elementos_forn_agua_po, set_error_elementos_forn_agua_po] = useState<boolean>(false);
  const [totais_aplicados_zona_po, set_error_totais_aplicados_zona_po] = useState<boolean>(false);
  const [totais_aplicados_hectare_po, set_error_totais_aplicados_hectare_po] = useState<boolean>(false);
  const [elementos_forn_solo_ko, set_error_elementos_forn_solo_ko] = useState<boolean>(false);
  const [elementos_forn_agua_ko, set_error_elementos_forn_agua_ko] = useState<boolean>(false);
  const [totais_aplicados_zona_ko, set_error_totais_aplicados_zona_ko] = useState<boolean>(false);
  const [totais_aplicados_hectare_ko, set_error_totais_aplicados_hectare_ko] = useState<boolean>(false);
  const [elementos_forn_solo_mgo, set_error_elementos_forn_solo_mgo] = useState<boolean>(false);
  const [elementos_forn_agua_mgo, set_error_elementos_forn_agua_mgo] = useState<boolean>(false);
  const [totais_aplicados_zona_mgo, set_error_totais_aplicados_zona_mgo] = useState<boolean>(false);
  const [totais_aplicados_hectare_mgo, set_error_totais_aplicados_hectare_mgo] = useState<boolean>(false);
  const [elementos_forn_solo_cao, set_error_elementos_forn_solo_cao] = useState<boolean>(false);
  const [elementos_forn_agua_cao, set_error_elementos_forn_agua_cao] = useState<boolean>(false);
  const [totais_aplicados_zona_cao, set_error_totais_aplicados_zona_cao] = useState<boolean>(false);
  const [totais_aplicados_hectare_cao, set_error_totais_aplicados_hectare_cao] = useState<boolean>(false);
  const [elementos_forn_solo_so, set_error_elementos_forn_solo_so] = useState<boolean>(false);
  const [elementos_forn_agua_so, set_error_elementos_forn_agua_so] = useState<boolean>(false);
  const [totais_aplicados_zona_so, set_error_totais_aplicados_zona_so] = useState<boolean>(false);
  const [totais_aplicados_hectare_so, set_error_totais_aplicados_hectare_so] = useState<boolean>(false);
  const [elementos_forn_solo_b, set_error_elementos_forn_solo_b] = useState<boolean>(false);
  const [elementos_forn_agua_b, set_error_elementos_forn_agua_b] = useState<boolean>(false);
  const [totais_aplicados_zona_b, set_error_totais_aplicados_zona_b] = useState<boolean>(false);
  const [totais_aplicados_hectare_b, set_error_totais_aplicados_hectare_b] = useState<boolean>(false);
  const message_apenas_numero = ("Apenas números são aceites");

  const camposNumericos = [
    "elementos_forn_solo_n",
    "elementos_forn_agua_n",
    "totais_aplicados_zona_n",
    "totais_aplicados_hectare_n",
    "elementos_forn_solo_po",
    "elementos_forn_agua_po",
    "totais_aplicados_zona_po",
    "totais_aplicados_hectare_po",
    "elementos_forn_solo_ko",
    "elementos_forn_agua_ko",
    "totais_aplicados_zona_ko",
    "totais_aplicados_hectare_ko",
    "elementos_forn_solo_mgo",
    "elementos_forn_agua_mgo",
    "totais_aplicados_zona_mgo",
    "totais_aplicados_hectare_mgo",
    "elementos_forn_solo_cao",
    "elementos_forn_agua_cao",
    "totais_aplicados_zona_cao",
    "totais_aplicados_hectare_cao",
    "elementos_forn_solo_so",
    "elementos_forn_agua_so",
    "totais_aplicados_zona_so",
    "totais_aplicados_hectare_so",
    "elementos_forn_solo_b",
    "elementos_forn_agua_b",
    "totais_aplicados_zona_b",
    "totais_aplicados_hectare_b",
  ];
  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const handleCloseDialog = () => {
    handleCancel()

    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };
  async function getExtraFields(id: number) {
    try {
      if (idCabecalho !== undefined) {
        let res = await get(auth.token.cookie_token,
          `/get_reg_operacoes_fertil_cabecalho_desdobramento/${id}`
        );
        if (res.status === 200) {

          const formattedData = res.data.result.map(formatar_numeros_tabelaExtra_5A);
          setExtraRows(formattedData);
        }
      };
      setIsLoading(false);
    } catch (error) {
      func_print("getExtraFields", error, true);
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      await getExtraFields(idCabecalho);
      return () => {
        setExtraRows([]);
      }
    })();
  }, [idCabecalho]);


  const handleCancel = () => {
    setCreateTable(false);
    setExtraRow(undefined);

  }

  const onInputChange = (event: any) => {
    const { name, value } = event.target;

    const isCampoNumerico = camposNumericos.includes(name);
    set_flag_editado(true)

    if (isCampoNumerico) {
      const valorSemFormatar = value.replace(/[^\d,]/g, "");
      const valorNumerico = parseFloat(value.replace(",", "."));

      if (!isNaN(valorNumerico)) {

        if (name === "elementos_forn_solo_n") {
          set_error_elementos_forn_solo_n(false);
        } else if (name === "elementos_forn_agua_n") {
          set_error_elementos_forn_agua_n(false);
        } else if (name === "totais_aplicados_zona_n") {
          set_error_totais_aplicados_zona_n(false);
        } else if (name === "totais_aplicados_hectare_n") {
          set_error_totais_aplicados_hectare_n(false);
        } else if (name === "elementos_forn_solo_po") {
          set_error_elementos_forn_solo_po(false);
        } else if (name === "elementos_forn_agua_po") {
          set_error_elementos_forn_agua_po(false);
        } else if (name === "totais_aplicados_zona_po") {
          set_error_totais_aplicados_zona_po(false);
        } else if (name === "totais_aplicados_hectare_po") {
          set_error_totais_aplicados_hectare_po(false);
        } else if (name === "elementos_forn_solo_ko") {
          set_error_elementos_forn_solo_ko(false);
        } else if (name === "elementos_forn_agua_ko") {
          set_error_elementos_forn_agua_ko(false);
        } else if (name === "totais_aplicados_zona_ko") {
          set_error_totais_aplicados_zona_ko(false);
        } else if (name === "totais_aplicados_hectare_ko") {
          set_error_totais_aplicados_hectare_ko(false);
        } else if (name === "elementos_forn_solo_mgo") {
          set_error_elementos_forn_solo_mgo(false);
        } else if (name === "elementos_forn_agua_mgo") {
          set_error_elementos_forn_agua_mgo(false);
        } else if (name === "totais_aplicados_zona_mgo") {
          set_error_totais_aplicados_zona_mgo(false);
        } else if (name === "totais_aplicados_hectare_mgo") {
          set_error_totais_aplicados_hectare_mgo(false);
        } else if (name === "elementos_forn_solo_cao") {
          set_error_elementos_forn_solo_cao(false);
        } else if (name === "elementos_forn_agua_cao") {
          set_error_elementos_forn_agua_cao(false);
        } else if (name === "totais_aplicados_zona_cao") {
          set_error_totais_aplicados_zona_cao(false);
        } else if (name === "totais_aplicados_hectare_cao") {
          set_error_totais_aplicados_hectare_cao(false);
        } else if (name === "elementos_forn_solo_so") {
          set_error_elementos_forn_solo_so(false);
        } else if (name === "elementos_forn_agua_so") {
          set_error_elementos_forn_agua_so(false);
        } else if (name === "totais_aplicados_zona_so") {
          set_error_totais_aplicados_zona_so(false);
        } else if (name === "totais_aplicados_hectare_so") {
          set_error_totais_aplicados_hectare_so(false);
        } else if (name === "elementos_forn_solo_b") {
          set_error_elementos_forn_solo_b(false);
        } else if (name === "elementos_forn_agua_b") {
          set_error_elementos_forn_agua_b(false);
        } else if (name === "totais_aplicados_zona_b") {
          set_error_totais_aplicados_zona_b(false);
        } else if (name === "totais_aplicados_hectare_b") {
          set_error_totais_aplicados_hectare_b(false);
        }
      } else {
        if (name === "elementos_forn_solo_n") {
          set_error_elementos_forn_solo_n(true);
        } else if (name === "elementos_forn_agua_n") {
          set_error_elementos_forn_agua_n(true);
        } else if (name === "totais_aplicados_zona_n") {
          set_error_totais_aplicados_zona_n(true);
        } else if (name === "totais_aplicados_hectare_n") {
          set_error_totais_aplicados_hectare_n(true);
        } else if (name === "elementos_forn_solo_po") {
          set_error_elementos_forn_solo_po(true);
        } else if (name === "elementos_forn_agua_po") {
          set_error_elementos_forn_agua_po(true);
        } else if (name === "totais_aplicados_zona_po") {
          set_error_totais_aplicados_zona_po(true);
        } else if (name === "totais_aplicados_hectare_po") {
          set_error_totais_aplicados_hectare_po(true);
        } else if (name === "elementos_forn_solo_ko") {
          set_error_elementos_forn_solo_ko(true);
        } else if (name === "elementos_forn_agua_ko") {
          set_error_elementos_forn_agua_ko(true);
        } else if (name === "totais_aplicados_zona_ko") {
          set_error_totais_aplicados_zona_ko(true);
        } else if (name === "totais_aplicados_hectare_ko") {
          set_error_totais_aplicados_hectare_ko(true);
        } else if (name === "elementos_forn_solo_mgo") {
          set_error_elementos_forn_solo_mgo(true);
        } else if (name === "elementos_forn_agua_mgo") {
          set_error_elementos_forn_agua_mgo(true);
        } else if (name === "totais_aplicados_zona_mgo") {
          set_error_totais_aplicados_zona_mgo(true);
        } else if (name === "totais_aplicados_hectare_mgo") {
          set_error_totais_aplicados_hectare_mgo(true);
        } else if (name === "elementos_forn_solo_cao") {
          set_error_elementos_forn_solo_cao(true);
        } else if (name === "elementos_forn_agua_cao") {
          set_error_elementos_forn_agua_cao(true);
        } else if (name === "totais_aplicados_zona_cao") {
          set_error_totais_aplicados_zona_cao(true);
        } else if (name === "totais_aplicados_hectare_cao") {
          set_error_totais_aplicados_hectare_cao(true);
        } else if (name === "elementos_forn_solo_so") {
          set_error_elementos_forn_solo_so(true);
        } else if (name === "elementos_forn_agua_so") {
          set_error_elementos_forn_agua_so(true);
        } else if (name === "totais_aplicados_zona_so") {
          set_error_totais_aplicados_zona_so(true);
        } else if (name === "totais_aplicados_hectare_so") {
          set_error_totais_aplicados_hectare_so(true);
        } else if (name === "elementos_forn_solo_b") {
          set_error_elementos_forn_solo_b(true);
        } else if (name === "elementos_forn_agua_b") {
          set_error_elementos_forn_agua_b(true);
        } else if (name === "totais_aplicados_zona_b") {
          set_error_totais_aplicados_zona_b(true);
        } else if (name === "totais_aplicados_hectare_b") {
          set_error_totais_aplicados_hectare_b(true);
        }
      }
      setExtraRow((prevExtraRow: any) => ({
        ...prevExtraRow,
        [name]: formatarNumero_ao_digitar(valorSemFormatar)
      }));
    } else {
      setExtraRow((prevExtraRow: any) => ({
        ...prevExtraRow,
        [name]: value,
      }));
    }
  };

  const handleSaveExtra = async () => {
    if (extraRow === undefined) {
      setMessage("Preencha a tabela antes de gravar.")
      setOpenSnackError(true)
    } else try {
      setIsLoading(true);
      let res = await post(auth.token.cookie_token, "new_reg_operacoes_fertil_desdobramento", {
        payload: {
          id_registo_fertil_two: 0,
          elementos_forn_solo_n: extraRow?.elementos_forn_solo_n === undefined ? null : desformatarNumero(extraRow.elementos_forn_solo_n),
          elementos_forn_agua_n: extraRow?.elementos_forn_agua_n === undefined ? null : desformatarNumero(extraRow.elementos_forn_agua_n),
          totais_aplicados_zona_n: extraRow?.totais_aplicados_zona_n === undefined ? null : desformatarNumero(extraRow.totais_aplicados_zona_n),
          totais_aplicados_hectare_n: extraRow?.totais_aplicados_hectare_n === undefined ? null : desformatarNumero(extraRow.totais_aplicados_hectare_n),
          elementos_forn_solo_po: extraRow?.elementos_forn_solo_po === undefined ? null : desformatarNumero(extraRow.elementos_forn_solo_po),
          elementos_forn_agua_po: extraRow?.elementos_forn_agua_po === undefined ? null : desformatarNumero(extraRow.elementos_forn_agua_po),
          totais_aplicados_zona_po: extraRow?.totais_aplicados_zona_po === undefined ? null : desformatarNumero(extraRow.totais_aplicados_zona_po),
          totais_aplicados_hectare_po: extraRow?.totais_aplicados_hectare_po === undefined ? null : desformatarNumero(extraRow.totais_aplicados_hectare_po),
          elementos_forn_solo_ko: extraRow?.elementos_forn_solo_ko === undefined ? null : desformatarNumero(extraRow.elementos_forn_solo_ko),
          elementos_forn_agua_ko: extraRow?.elementos_forn_agua_ko === undefined ? null : desformatarNumero(extraRow.elementos_forn_agua_ko),
          totais_aplicados_zona_ko: extraRow?.totais_aplicados_zona_ko === undefined ? null : desformatarNumero(extraRow.totais_aplicados_zona_ko),
          totais_aplicados_hectare_ko: extraRow?.totais_aplicados_hectare_ko === undefined ? null : desformatarNumero(extraRow.totais_aplicados_hectare_ko),
          elementos_forn_solo_mgo: extraRow?.elementos_forn_solo_mgo === undefined ? null : desformatarNumero(extraRow.elementos_forn_solo_mgo),
          elementos_forn_agua_mgo: extraRow?.elementos_forn_agua_mgo === undefined ? null : desformatarNumero(extraRow.elementos_forn_agua_mgo),
          totais_aplicados_zona_mgo: extraRow?.totais_aplicados_zona_mgo === undefined ? null : desformatarNumero(extraRow.totais_aplicados_zona_mgo),
          totais_aplicados_hectare_mgo: extraRow?.totais_aplicados_hectare_mgo === undefined ? null : desformatarNumero(extraRow.totais_aplicados_hectare_mgo),
          elementos_forn_solo_cao: extraRow?.elementos_forn_solo_cao === undefined ? null : desformatarNumero(extraRow.elementos_forn_solo_cao),
          elementos_forn_agua_cao: extraRow?.elementos_forn_agua_cao === undefined ? null : desformatarNumero(extraRow.elementos_forn_agua_cao),
          totais_aplicados_zona_cao: extraRow?.totais_aplicados_zona_cao === undefined ? null : desformatarNumero(extraRow.totais_aplicados_zona_cao),
          totais_aplicados_hectare_cao: extraRow?.totais_aplicados_hectare_cao === undefined ? null : desformatarNumero(extraRow.totais_aplicados_hectare_cao),
          elementos_forn_solo_so: extraRow?.elementos_forn_solo_so === undefined ? null : desformatarNumero(extraRow.elementos_forn_solo_so),
          elementos_forn_agua_so: extraRow?.elementos_forn_agua_so === undefined ? null : desformatarNumero(extraRow.elementos_forn_agua_so),
          totais_aplicados_zona_so: extraRow?.totais_aplicados_zona_so === undefined ? null : desformatarNumero(extraRow.totais_aplicados_zona_so),
          totais_aplicados_hectare_so: extraRow?.totais_aplicados_hectare_so === undefined ? null : desformatarNumero(extraRow.totais_aplicados_hectare_so),
          elementos_forn_solo_b: extraRow?.elementos_forn_solo_b === undefined ? null : desformatarNumero(extraRow.elementos_forn_solo_b),
          elementos_forn_agua_b: extraRow?.elementos_forn_agua_b === undefined ? null : desformatarNumero(extraRow.elementos_forn_agua_b),
          totais_aplicados_zona_b: extraRow?.totais_aplicados_zona_b === undefined ? null : desformatarNumero(extraRow.totais_aplicados_zona_b),
          totais_aplicados_hectare_b: extraRow?.totais_aplicados_hectare_b === undefined ? null : desformatarNumero(extraRow.totais_aplicados_hectare_b),
          elementos_forn_solo_ob: extraRow?.elementos_forn_solo_ob === undefined ? null : extraRow.elementos_forn_solo_ob,
          elementos_forn_agua_ob: extraRow?.elementos_forn_agua_ob === undefined ? null : extraRow.elementos_forn_agua_ob,
          totais_aplicados_zona_ob: extraRow?.totais_aplicados_zona_ob === undefined ? null : extraRow.totais_aplicados_zona_ob,
          totais_aplicados_hectare_ob: extraRow?.totais_aplicados_hectare_ob === undefined ? null : extraRow.totais_aplicados_hectare_ob,

          id_registo_fertil_cabecalho: idCabecalho,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: "",
        }
      });
      if (res.status === 200) {
        setMessage("Gravado com sucesso!");
        setOpenSnackSuccess(true);
        setCreateTable(false);
        set_flag_editado(false)

        setExtraRow(undefined);
        setExtraRows((prevRows) => {
          return [...prevRows, formatar_numeros_tabelaExtra_5A(res.data.result)];
        })
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error: any) {
      func_print("handleSaveExtra", error, true);
      // if (error?.status === 409) {

      //   setMessage(error?.response.data.detail);
      //   setOpenSnackError(true);
      // } else {
      //   setMessage("Erro ao efetuar a sua operação!");
      //   setOpenSnackError(true);
      // }

      if ((error as any)?.response?.data?.message) {
        setMessage((error as any).response.data.message);
      } else {
        setMessage("Erro ao efetuar a sua operação!");
      }
      setOpenSnackError(true);

      setIsLoading(false);
    }
  };

  // EDITAR
  const handleEdit = (obj: IPage5ADesdobramento) => {
    setExtraRow(obj);
  };

  const onInputChange_editar = (event: any) => {
    const { name, value } = event.target;

    const isCampoNumerico = camposNumericos.includes(name);
    set_flag_editado(true)


    if (isCampoNumerico) {
      // Validação e formatação para campos numéricos
      const valorSemFormatar = value.replace(/[^\d,]/g, "");
      const valorNumerico = parseFloat(valorSemFormatar.replace(",", "."));

      if (!isNaN(valorNumerico)) {
        if (name === "elementos_forn_solo_n") {
          set_error_elementos_forn_solo_n(false);
        } else if (name === "elementos_forn_agua_n") {
          set_error_elementos_forn_agua_n(false);
        } else if (name === "totais_aplicados_zona_n") {
          set_error_totais_aplicados_zona_n(false);
        } else if (name === "totais_aplicados_hectare_n") {
          set_error_totais_aplicados_hectare_n(false);
        } else if (name === "elementos_forn_solo_po") {
          set_error_elementos_forn_solo_po(false);
        } else if (name === "elementos_forn_agua_po") {
          set_error_elementos_forn_agua_po(false);
        } else if (name === "totais_aplicados_zona_po") {
          set_error_totais_aplicados_zona_po(false);
        } else if (name === "totais_aplicados_hectare_po") {
          set_error_totais_aplicados_hectare_po(false);
        } else if (name === "elementos_forn_solo_ko") {
          set_error_elementos_forn_solo_ko(false);
        } else if (name === "elementos_forn_agua_ko") {
          set_error_elementos_forn_agua_ko(false);
        } else if (name === "totais_aplicados_zona_ko") {
          set_error_totais_aplicados_zona_ko(false);
        } else if (name === "totais_aplicados_hectare_ko") {
          set_error_totais_aplicados_hectare_ko(false);
        } else if (name === "elementos_forn_solo_mgo") {
          set_error_elementos_forn_solo_mgo(false);
        } else if (name === "elementos_forn_agua_mgo") {
          set_error_elementos_forn_agua_mgo(false);
        } else if (name === "totais_aplicados_zona_mgo") {
          set_error_totais_aplicados_zona_mgo(false);
        } else if (name === "totais_aplicados_hectare_mgo") {
          set_error_totais_aplicados_hectare_mgo(false);
        } else if (name === "elementos_forn_solo_cao") {
          set_error_elementos_forn_solo_cao(false);
        } else if (name === "elementos_forn_agua_cao") {
          set_error_elementos_forn_agua_cao(false);
        } else if (name === "totais_aplicados_zona_cao") {
          set_error_totais_aplicados_zona_cao(false);
        } else if (name === "totais_aplicados_hectare_cao") {
          set_error_totais_aplicados_hectare_cao(false);
        } else if (name === "elementos_forn_solo_so") {
          set_error_elementos_forn_solo_so(false);
        } else if (name === "elementos_forn_agua_so") {
          set_error_elementos_forn_agua_so(false);
        } else if (name === "totais_aplicados_zona_so") {
          set_error_totais_aplicados_zona_so(false);
        } else if (name === "totais_aplicados_hectare_so") {
          set_error_totais_aplicados_hectare_so(false);
        } else if (name === "elementos_forn_solo_b") {
          set_error_elementos_forn_solo_b(false);
        } else if (name === "elementos_forn_agua_b") {
          set_error_elementos_forn_agua_b(false);
        } else if (name === "totais_aplicados_zona_b") {
          set_error_totais_aplicados_zona_b(false);
        } else if (name === "totais_aplicados_hectare_b") {
          set_error_totais_aplicados_hectare_b(false);
        }
      } else {
        if (name === "elementos_forn_solo_n") {
          set_error_elementos_forn_solo_n(true);
        } else if (name === "elementos_forn_agua_n") {
          set_error_elementos_forn_agua_n(true);
        } else if (name === "totais_aplicados_zona_n") {
          set_error_totais_aplicados_zona_n(true);
        } else if (name === "totais_aplicados_hectare_n") {
          set_error_totais_aplicados_hectare_n(true);
        } else if (name === "elementos_forn_solo_po") {
          set_error_elementos_forn_solo_po(true);
        } else if (name === "elementos_forn_agua_po") {
          set_error_elementos_forn_agua_po(true);
        } else if (name === "totais_aplicados_zona_po") {
          set_error_totais_aplicados_zona_po(true);
        } else if (name === "totais_aplicados_hectare_po") {
          set_error_totais_aplicados_hectare_po(true);
        } else if (name === "elementos_forn_solo_ko") {
          set_error_elementos_forn_solo_ko(true);
        } else if (name === "elementos_forn_agua_ko") {
          set_error_elementos_forn_agua_ko(true);
        } else if (name === "totais_aplicados_zona_ko") {
          set_error_totais_aplicados_zona_ko(true);
        } else if (name === "totais_aplicados_hectare_ko") {
          set_error_totais_aplicados_hectare_ko(true);
        } else if (name === "elementos_forn_solo_mgo") {
          set_error_elementos_forn_solo_mgo(true);
        } else if (name === "elementos_forn_agua_mgo") {
          set_error_elementos_forn_agua_mgo(true);
        } else if (name === "totais_aplicados_zona_mgo") {
          set_error_totais_aplicados_zona_mgo(true);
        } else if (name === "totais_aplicados_hectare_mgo") {
          set_error_totais_aplicados_hectare_mgo(true);
        } else if (name === "elementos_forn_solo_cao") {
          set_error_elementos_forn_solo_cao(true);
        } else if (name === "elementos_forn_agua_cao") {
          set_error_elementos_forn_agua_cao(true);
        } else if (name === "totais_aplicados_zona_cao") {
          set_error_totais_aplicados_zona_cao(true);
        } else if (name === "totais_aplicados_hectare_cao") {
          set_error_totais_aplicados_hectare_cao(true);
        } else if (name === "elementos_forn_solo_so") {
          set_error_elementos_forn_solo_so(true);
        } else if (name === "elementos_forn_agua_so") {
          set_error_elementos_forn_agua_so(true);
        } else if (name === "totais_aplicados_zona_so") {
          set_error_totais_aplicados_zona_so(true);
        } else if (name === "totais_aplicados_hectare_so") {
          set_error_totais_aplicados_hectare_so(true);
        } else if (name === "elementos_forn_solo_b") {
          set_error_elementos_forn_solo_b(true);
        } else if (name === "elementos_forn_agua_b") {
          set_error_elementos_forn_agua_b(true);
        } else if (name === "totais_aplicados_zona_b") {
          set_error_totais_aplicados_zona_b(true);
        } else if (name === "totais_aplicados_hectare_b") {
          set_error_totais_aplicados_hectare_b(true);
        }
      }
      setExtraRow((prevNewRows: any) => ({
        ...prevNewRows,
        [name]: formatarNumero_ao_digitar(valorSemFormatar)
      }));
    } else {
      setExtraRow((prevNewRows: any) => ({
        ...prevNewRows,
        [name]: value,
      }));
    }

  };

  const handleUpdateObs = async () => {

    try {
      let res = await post(auth.token.cookie_token, "update_reg_operacoes_fertil_desdobramento", {
        payload: {
          id_registo_fertil_two: extraRow?.id_registo_fertil_two,
          elementos_forn_solo_n: extraRow?.elementos_forn_solo_n === undefined ? null : desformatarNumero_return_null(extraRow.elementos_forn_solo_n),
          elementos_forn_agua_n: extraRow?.elementos_forn_agua_n === undefined ? null : desformatarNumero_return_null(extraRow.elementos_forn_agua_n),
          totais_aplicados_zona_n: extraRow?.totais_aplicados_zona_n === undefined ? null : desformatarNumero_return_null(extraRow.totais_aplicados_zona_n),
          totais_aplicados_hectare_n: extraRow?.totais_aplicados_hectare_n === undefined ? null : desformatarNumero_return_null(extraRow.totais_aplicados_hectare_n),
          elementos_forn_solo_po: extraRow?.elementos_forn_solo_po === undefined ? null : desformatarNumero_return_null(extraRow.elementos_forn_solo_po),
          elementos_forn_agua_po: extraRow?.elementos_forn_agua_po === undefined ? null : desformatarNumero_return_null(extraRow.elementos_forn_agua_po),
          totais_aplicados_zona_po: extraRow?.totais_aplicados_zona_po === undefined ? null : desformatarNumero_return_null(extraRow.totais_aplicados_zona_po),
          totais_aplicados_hectare_po: extraRow?.totais_aplicados_hectare_po === undefined ? null : desformatarNumero_return_null(extraRow.totais_aplicados_hectare_po),
          elementos_forn_solo_ko: extraRow?.elementos_forn_solo_ko === undefined ? null : desformatarNumero_return_null(extraRow.elementos_forn_solo_ko),
          elementos_forn_agua_ko: extraRow?.elementos_forn_agua_ko === undefined ? null : desformatarNumero_return_null(extraRow.elementos_forn_agua_ko),
          totais_aplicados_zona_ko: extraRow?.totais_aplicados_zona_ko === undefined ? null : desformatarNumero_return_null(extraRow.totais_aplicados_zona_ko),
          totais_aplicados_hectare_ko: extraRow?.totais_aplicados_hectare_ko === undefined ? null : desformatarNumero_return_null(extraRow.totais_aplicados_hectare_ko),
          elementos_forn_solo_mgo: extraRow?.elementos_forn_solo_mgo === undefined ? null : desformatarNumero_return_null(extraRow.elementos_forn_solo_mgo),
          elementos_forn_agua_mgo: extraRow?.elementos_forn_agua_mgo === undefined ? null : desformatarNumero_return_null(extraRow.elementos_forn_agua_mgo),
          totais_aplicados_zona_mgo: extraRow?.totais_aplicados_zona_mgo === undefined ? null : desformatarNumero_return_null(extraRow.totais_aplicados_zona_mgo),
          totais_aplicados_hectare_mgo: extraRow?.totais_aplicados_hectare_mgo === undefined ? null : desformatarNumero_return_null(extraRow.totais_aplicados_hectare_mgo),
          elementos_forn_solo_cao: extraRow?.elementos_forn_solo_cao === undefined ? null : desformatarNumero_return_null(extraRow.elementos_forn_solo_cao),
          elementos_forn_agua_cao: extraRow?.elementos_forn_agua_cao === undefined ? null : desformatarNumero_return_null(extraRow.elementos_forn_agua_cao),
          totais_aplicados_zona_cao: extraRow?.totais_aplicados_zona_cao === undefined ? null : desformatarNumero_return_null(extraRow.totais_aplicados_zona_cao),
          totais_aplicados_hectare_cao: extraRow?.totais_aplicados_hectare_cao === undefined ? null : desformatarNumero_return_null(extraRow.totais_aplicados_hectare_cao),
          elementos_forn_solo_so: extraRow?.elementos_forn_solo_so === undefined ? null : desformatarNumero_return_null(extraRow.elementos_forn_solo_so),
          elementos_forn_agua_so: extraRow?.elementos_forn_agua_so === undefined ? null : desformatarNumero_return_null(extraRow.elementos_forn_agua_so),
          totais_aplicados_zona_so: extraRow?.totais_aplicados_zona_so === undefined ? null : desformatarNumero_return_null(extraRow.totais_aplicados_zona_so),
          totais_aplicados_hectare_so: extraRow?.totais_aplicados_hectare_so === undefined ? null : desformatarNumero_return_null(extraRow.totais_aplicados_hectare_so),
          elementos_forn_solo_b: extraRow?.elementos_forn_solo_b === undefined ? null : desformatarNumero_return_null(extraRow.elementos_forn_solo_b),
          elementos_forn_agua_b: extraRow?.elementos_forn_agua_b === undefined ? null : desformatarNumero_return_null(extraRow.elementos_forn_agua_b),
          totais_aplicados_zona_b: extraRow?.totais_aplicados_zona_b === undefined ? null : desformatarNumero_return_null(extraRow.totais_aplicados_zona_b),
          totais_aplicados_hectare_b: extraRow?.totais_aplicados_hectare_b === undefined ? null : desformatarNumero_return_null(extraRow.totais_aplicados_hectare_b),
          elementos_forn_solo_ob: extraRow?.elementos_forn_solo_ob === undefined ? null : extraRow.elementos_forn_solo_ob,
          elementos_forn_agua_ob: extraRow?.elementos_forn_agua_ob === undefined ? null : extraRow.elementos_forn_agua_ob,
          totais_aplicados_zona_ob: extraRow?.totais_aplicados_zona_ob === undefined ? null : extraRow.totais_aplicados_zona_ob,
          totais_aplicados_hectare_ob: extraRow?.totais_aplicados_hectare_ob === undefined ? null : extraRow.totais_aplicados_hectare_ob,
          id_registo_fertil_cabecalho: extraRow?.id_registo_fertil_cabecalho,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: "",
        }
      })
      if (res.status === 200) {
        setMessage("Registado com sucesso!");

        const updatedRows = extraRows.map((row) => {
          if (row.id_registo_fertil_two === extraRow?.id_registo_fertil_two) {
            return formatar_numeros_tabelaExtra_5A(res.data.result)
          } else {
            return { ...row };
          }
        });
        set_flag_editado(false)

        setExtraRows(updatedRows !== undefined ? updatedRows : []);
        setExtraRow(undefined);
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);

    } catch (error: any) {
      func_print("handleUpdateObs", error, true);
      if (error?.status === 409) {

        setMessage(error?.response.data.detail);
        setOpenSnackError(true);
      } else {
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }

      setIsLoading(false);
    }

  }

  //Delete
  const handleClickOpenDeleteExtra = (obj: IPage5ADesdobramento) => {
    setExtraRow(obj);

    setOpenDeleteExtra(true);
  };

  const handleDeleteExtra = async () => {
    try {
      setIsLoading(true);
      let res = await del(auth.token.cookie_token, `/delete__reg_operacoes_fertil_desdobramento/${extraRow?.id_registo_fertil_two}`);

      if (res.status === 200) {
        setMessage("Registo eliminado com sucesso!");
        setOpenDeleteExtra(false);
        setExtraRow(undefined);

        setExtraRows((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_registo_fertil_two !== extraRow?.id_registo_fertil_two),
        ]);
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleDeleteExtra", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };


  return (
    <>
      {/* Se não houver registos mostra tabela vazia e botão criar  */}
      {extraRows.length <= 0 && createTable === false && (
        <>
          <TableRow>
            <StyledTableHead colSpan={5}>
              Elementos fornecidos pelo solo (cf. Análise de)
              terras
            </StyledTableHead>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <TableCell rowSpan={4}>
              <Box sx={{ display: "flex", justifyContent: "end", }} >
                {is_historico === true ? <></> :

                  <BarraDeFerramentas
                    mostrarBotaoNovo
                    textoBotaoNovo="Registar"
                    aoClicarNovo={() => setCreateTable(true)}
                  />}
              </Box>
            </TableCell>
          </TableRow>
          <TableRow>
            <StyledTableHead colSpan={5}>Elementos fornecidos pela água da rega (cf. Análise de água de rega) </StyledTableHead>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableHead colSpan={5}>
              <Stack direction="row" justifyContent="center" alignItems="center">
                Elementos fornecidos pela água da rega (cf. Análise de água de rega)
                <BasicPopover text={" Preenchimento obrigatório para os beneficiário com compromissos ativos na intervenção «Uso Eficiente da água»"} />
              </Stack>
            </StyledTableHead>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableHead colSpan={5}> Totais aplicados por hectare (kg/há) </StyledTableHead>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
        </>
      )}
      {/* Se não houver registos e botão criar === true mostra tabela para criar  */}
      {extraRows.length <= 0 && createTable && (
        <>
          <TableRow>
            <StyledTableHead colSpan={5}> Elementos fornecidos pelo solo (cf. Análise de terras) </StyledTableHead>
            <StyledTableCell>
              <CustomTextField
                name="elementos_forn_solo_n"
                value={extraRow?.elementos_forn_solo_n}
                onChange={onInputChange}
                error={elementos_forn_solo_n}
                helperText={elementos_forn_solo_n ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="elementos_forn_solo_po"
                value={extraRow?.elementos_forn_solo_po}
                onChange={onInputChange}
                error={elementos_forn_solo_po}
                helperText={elementos_forn_solo_po ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="elementos_forn_solo_ko"
                value={extraRow?.elementos_forn_solo_ko}
                onChange={onInputChange}
                error={elementos_forn_solo_ko}
                helperText={elementos_forn_solo_ko ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="elementos_forn_solo_mgo"
                value={extraRow?.elementos_forn_solo_mgo}
                onChange={onInputChange}
                error={elementos_forn_solo_mgo}
                helperText={elementos_forn_solo_mgo ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="elementos_forn_solo_cao"
                value={extraRow?.elementos_forn_solo_cao}
                onChange={onInputChange}
                error={elementos_forn_solo_cao}
                helperText={elementos_forn_solo_cao ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="elementos_forn_solo_so"
                value={extraRow?.elementos_forn_solo_so}
                onChange={onInputChange}
                error={elementos_forn_solo_so}
                helperText={elementos_forn_solo_so ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="elementos_forn_solo_b"
                value={extraRow?.elementos_forn_solo_b}
                onChange={onInputChange}
                error={elementos_forn_solo_b}
                helperText={elementos_forn_solo_b ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="elementos_forn_solo_ob"
                value={extraRow?.elementos_forn_solo_ob}
                onChange={onInputChange}
              />
            </StyledTableCell>
            <StyledTableCell rowSpan={4}>
              <Stack direction="row" justifyContent="center">
                <ButtonCadernos
                  mostrarBotaoCancelar
                  aoClicarCancelar={() => {
                    if (flag_editado) {
                      set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                    } else {
                      handleCancel()
                    }
                  }}
                  mostrarBotaoGravar
                  aoClicarGravar={() => handleSaveExtra()}
                />
              </Stack>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableHead colSpan={5}>
              Elementos fornecidos pela água da rega (cf. Análise
              de água de rega)
            </StyledTableHead>
            <StyledTableCell>
              <CustomTextField
                name="elementos_forn_agua_n"
                value={extraRow?.elementos_forn_agua_n}
                onChange={onInputChange}
                error={elementos_forn_agua_n}
                helperText={elementos_forn_agua_n ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="elementos_forn_agua_po"
                value={extraRow?.elementos_forn_agua_po}
                onChange={onInputChange}
                error={elementos_forn_agua_po}
                helperText={elementos_forn_agua_po ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="elementos_forn_agua_ko"
                value={extraRow?.elementos_forn_agua_ko}
                onChange={onInputChange}
                error={elementos_forn_agua_ko}
                helperText={elementos_forn_agua_ko ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="elementos_forn_agua_mgo"
                value={extraRow?.elementos_forn_agua_mgo}
                onChange={onInputChange}
                error={elementos_forn_agua_mgo}
                helperText={elementos_forn_agua_mgo ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="elementos_forn_agua_cao"
                value={extraRow?.elementos_forn_agua_cao}
                onChange={onInputChange}
                error={elementos_forn_agua_cao}
                helperText={elementos_forn_agua_cao ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="elementos_forn_agua_so"
                value={extraRow?.elementos_forn_agua_so}
                onChange={onInputChange}
                error={elementos_forn_agua_so}
                helperText={elementos_forn_agua_so ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="elementos_forn_agua_b"
                value={extraRow?.elementos_forn_agua_b}
                onChange={onInputChange}
                error={elementos_forn_agua_b}
                helperText={elementos_forn_agua_b ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="elementos_forn_agua_ob"
                value={extraRow?.elementos_forn_agua_ob}
                onChange={onInputChange}
              />
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableHead colSpan={5}>
              Totais aplicados na subparcela ou na zona homogénea
              (kg)
            </StyledTableHead>
            <StyledTableCell>
              <CustomTextField
                name="totais_aplicados_zona_n"
                value={extraRow?.totais_aplicados_zona_n}
                onChange={onInputChange}
                error={totais_aplicados_zona_n}
                helperText={totais_aplicados_zona_n ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_aplicados_zona_po"
                value={extraRow?.totais_aplicados_zona_po}
                onChange={onInputChange}
                error={totais_aplicados_zona_po}
                helperText={totais_aplicados_zona_po ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_aplicados_zona_ko"
                value={extraRow?.totais_aplicados_zona_ko}
                onChange={onInputChange}
                error={totais_aplicados_zona_ko}
                helperText={totais_aplicados_zona_ko ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_aplicados_zona_mgo"
                value={extraRow?.totais_aplicados_zona_mgo}
                onChange={onInputChange}
                error={totais_aplicados_zona_mgo}
                helperText={totais_aplicados_zona_mgo ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_aplicados_zona_cao"
                value={extraRow?.totais_aplicados_zona_cao}
                onChange={onInputChange}
                error={totais_aplicados_zona_cao}
                helperText={totais_aplicados_zona_cao ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_aplicados_zona_so"
                value={extraRow?.totais_aplicados_zona_so}
                onChange={onInputChange}
                error={totais_aplicados_zona_so}
                helperText={totais_aplicados_zona_so ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_aplicados_zona_b"
                value={extraRow?.totais_aplicados_zona_b}
                onChange={onInputChange}
                error={totais_aplicados_zona_b}
                helperText={totais_aplicados_zona_b ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_aplicados_zona_ob"
                value={extraRow?.totais_aplicados_zona_ob}
                onChange={onInputChange}
              />
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableHead colSpan={5}>
              Totais aplicados por hectare (kg/há)
            </StyledTableHead>
            <StyledTableCell>
              <CustomTextField
                name="totais_aplicados_hectare_n"
                value={extraRow?.totais_aplicados_hectare_n}
                onChange={onInputChange}
                error={totais_aplicados_hectare_n}
                helperText={totais_aplicados_hectare_n ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_aplicados_hectare_po"
                value={extraRow?.totais_aplicados_hectare_po}
                onChange={onInputChange}
                error={totais_aplicados_hectare_po}
                helperText={totais_aplicados_hectare_po ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_aplicados_hectare_ko"
                value={extraRow?.totais_aplicados_hectare_ko}
                onChange={onInputChange}
                error={totais_aplicados_hectare_ko}
                helperText={totais_aplicados_hectare_ko ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_aplicados_hectare_mgo"
                value={extraRow?.totais_aplicados_hectare_mgo}
                onChange={onInputChange}
                error={totais_aplicados_hectare_mgo}
                helperText={totais_aplicados_hectare_mgo ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_aplicados_hectare_cao"
                value={extraRow?.totais_aplicados_hectare_cao}
                onChange={onInputChange}
                error={totais_aplicados_hectare_cao}
                helperText={totais_aplicados_hectare_cao ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_aplicados_hectare_so"
                value={extraRow?.totais_aplicados_hectare_so}
                onChange={onInputChange}
                error={totais_aplicados_hectare_so}
                helperText={totais_aplicados_hectare_so ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_aplicados_hectare_b"
                value={extraRow?.totais_aplicados_hectare_b}
                onChange={onInputChange}
                error={totais_aplicados_hectare_b}
                helperText={totais_aplicados_hectare_b ? message_apenas_numero : ""}
              />
            </StyledTableCell>
            <StyledTableCell>
              <CustomTextField
                name="totais_aplicados_hectare_ob"
                value={extraRow?.totais_aplicados_hectare_ob}
                onChange={onInputChange}
              />
            </StyledTableCell>
          </TableRow>
        </>
      )}

      {/* Se houver registos mostra tabela para editar  */}
      {extraRows.length > 0 &&
        extraRows.map((extra, k) =>
          extraRow?.id_registo_fertil_two === extra.id_registo_fertil_two ? (
            <React.Fragment key={k}>
              <TableRow>
                <StyledTableHead colSpan={5}>
                  Elementos fornecidos pelo solo (cf. Análise de
                  terras)
                </StyledTableHead>
                <StyledTableCell>
                  <CustomTextField
                    name="elementos_forn_solo_n"
                    value={extraRow?.elementos_forn_solo_n}
                    onChange={onInputChange_editar}
                    error={elementos_forn_solo_n}
                    helperText={elementos_forn_solo_n ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="elementos_forn_solo_po"
                    value={extraRow?.elementos_forn_solo_po}
                    onChange={onInputChange_editar}
                    error={elementos_forn_solo_po}
                    helperText={elementos_forn_solo_po ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="elementos_forn_solo_ko"
                    value={extraRow?.elementos_forn_solo_ko}
                    onChange={onInputChange_editar}
                    error={elementos_forn_solo_ko}
                    helperText={elementos_forn_solo_ko ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="elementos_forn_solo_mgo"
                    value={extraRow?.elementos_forn_solo_mgo}
                    onChange={onInputChange_editar}
                    error={elementos_forn_solo_mgo}
                    helperText={elementos_forn_solo_mgo ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="elementos_forn_solo_cao"
                    value={extraRow?.elementos_forn_solo_cao}
                    onChange={onInputChange_editar}
                    error={elementos_forn_solo_cao}
                    helperText={elementos_forn_solo_cao ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="elementos_forn_solo_so"
                    value={extraRow?.elementos_forn_solo_so}
                    onChange={onInputChange_editar}
                    error={elementos_forn_solo_so}
                    helperText={elementos_forn_solo_so ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="elementos_forn_solo_b"
                    value={extraRow?.elementos_forn_solo_b}
                    onChange={onInputChange_editar}
                    error={elementos_forn_solo_b}
                    helperText={elementos_forn_solo_b ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="elementos_forn_solo_ob"
                    value={extraRow?.elementos_forn_solo_ob}
                    onChange={onInputChange_editar}
                  />
                </StyledTableCell>
                <StyledTableCell rowSpan={4}>
                  <ButtonCadernos
                    mostrarBotaoGravar
                    aoClicarGravar={() => handleUpdateObs()}
                    mostrarBotaoCancelar
                    aoClicarCancelar={() => {
                      if (flag_editado) {
                        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                      } else {
                        handleCancel()
                      }
                    }}
                  />
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableHead colSpan={5}>
                  Elementos fornecidos pela água da rega (cf.
                  Análise de água de rega)
                </StyledTableHead>
                <StyledTableCell>
                  <CustomTextField
                    name="elementos_forn_agua_n"
                    value={extraRow?.elementos_forn_agua_n}
                    onChange={onInputChange_editar}
                    error={elementos_forn_agua_n}
                    helperText={elementos_forn_agua_n ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="elementos_forn_agua_po"
                    value={extraRow?.elementos_forn_agua_po}
                    onChange={onInputChange_editar}
                    error={elementos_forn_agua_po}
                    helperText={elementos_forn_agua_po ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="elementos_forn_agua_ko"
                    value={extraRow?.elementos_forn_agua_ko}
                    onChange={onInputChange_editar}
                    error={elementos_forn_agua_ko}
                    helperText={elementos_forn_agua_ko ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="elementos_forn_agua_mgo"
                    value={extraRow?.elementos_forn_agua_mgo}
                    onChange={onInputChange_editar}
                    error={elementos_forn_agua_mgo}
                    helperText={elementos_forn_agua_mgo ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="elementos_forn_agua_cao"
                    value={extraRow?.elementos_forn_agua_cao}
                    onChange={onInputChange_editar}
                    error={elementos_forn_agua_cao}
                    helperText={elementos_forn_agua_cao ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="elementos_forn_agua_so"
                    value={extraRow?.elementos_forn_agua_so}
                    onChange={onInputChange_editar}
                    error={elementos_forn_agua_so}
                    helperText={elementos_forn_agua_so ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="elementos_forn_agua_b"
                    value={extraRow?.elementos_forn_agua_b}
                    onChange={onInputChange_editar}
                    error={elementos_forn_agua_b}
                    helperText={elementos_forn_agua_b ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="elementos_forn_agua_ob"
                    value={extraRow?.elementos_forn_agua_ob}
                    onChange={onInputChange_editar}
                  />
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableHead colSpan={5}>
                  Totais aplicados na subparcela ou na zona
                  homogénea (kg)
                </StyledTableHead>
                <StyledTableCell>
                  <CustomTextField
                    name="totais_aplicados_zona_n"
                    value={extraRow?.totais_aplicados_zona_n}
                    onChange={onInputChange_editar}
                    error={totais_aplicados_zona_n}
                    helperText={totais_aplicados_zona_n ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="totais_aplicados_zona_po"
                    value={extraRow?.totais_aplicados_zona_po}
                    onChange={onInputChange_editar}
                    error={totais_aplicados_zona_po}
                    helperText={totais_aplicados_zona_po ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="totais_aplicados_zona_ko"
                    value={extraRow?.totais_aplicados_zona_ko}
                    onChange={onInputChange_editar}
                    error={totais_aplicados_zona_ko}
                    helperText={totais_aplicados_zona_ko ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="totais_aplicados_zona_mgo"
                    value={extraRow?.totais_aplicados_zona_mgo}
                    onChange={onInputChange_editar}
                    error={totais_aplicados_zona_mgo}
                    helperText={totais_aplicados_zona_mgo ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="totais_aplicados_zona_cao"
                    value={extraRow?.totais_aplicados_zona_cao}
                    onChange={onInputChange_editar}
                    error={totais_aplicados_zona_cao}
                    helperText={totais_aplicados_zona_cao ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="totais_aplicados_zona_so"
                    value={extraRow?.totais_aplicados_zona_so}
                    onChange={onInputChange_editar}
                    error={totais_aplicados_zona_so}
                    helperText={totais_aplicados_zona_so ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="totais_aplicados_zona_b"
                    value={extraRow?.totais_aplicados_zona_b}
                    onChange={onInputChange_editar}
                    error={totais_aplicados_zona_b}
                    helperText={totais_aplicados_zona_b ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="totais_aplicados_zona_ob"
                    value={extraRow?.totais_aplicados_zona_ob}
                    onChange={onInputChange_editar}
                  />
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableHead colSpan={5}>
                  Totais aplicados por hectare (kg/há)
                </StyledTableHead>
                <StyledTableCell>
                  <CustomTextField
                    name="totais_aplicados_hectare_n"
                    value={extraRow?.totais_aplicados_hectare_n}
                    onChange={onInputChange_editar}
                    error={totais_aplicados_hectare_n}
                    helperText={totais_aplicados_hectare_n ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="totais_aplicados_hectare_po"
                    value={extraRow?.totais_aplicados_hectare_po}
                    onChange={onInputChange_editar}
                    error={totais_aplicados_hectare_po}
                    helperText={totais_aplicados_hectare_po ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="totais_aplicados_hectare_ko"
                    value={extraRow?.totais_aplicados_hectare_ko}
                    onChange={onInputChange_editar}
                    error={totais_aplicados_hectare_ko}
                    helperText={totais_aplicados_hectare_ko ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="totais_aplicados_hectare_mgo"
                    value={extraRow?.totais_aplicados_hectare_mgo}
                    onChange={onInputChange_editar}
                    error={totais_aplicados_hectare_mgo}
                    helperText={totais_aplicados_hectare_mgo ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="totais_aplicados_hectare_cao"
                    value={extraRow?.totais_aplicados_hectare_cao}
                    onChange={onInputChange_editar}
                    error={totais_aplicados_hectare_cao}
                    helperText={totais_aplicados_hectare_cao ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="totais_aplicados_hectare_so"
                    value={extraRow?.totais_aplicados_hectare_so}
                    onChange={onInputChange_editar}
                    error={totais_aplicados_hectare_so}
                    helperText={totais_aplicados_hectare_so ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="totais_aplicados_hectare_b"
                    value={extraRow?.totais_aplicados_hectare_b}
                    onChange={onInputChange_editar}
                    error={totais_aplicados_hectare_b}
                    helperText={totais_aplicados_hectare_b ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="totais_aplicados_hectare_ob"
                    value={extraRow?.totais_aplicados_hectare_ob}
                    onChange={onInputChange_editar}
                    error={totais_aplicados_hectare_b}
                    helperText={totais_aplicados_hectare_b ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
              </TableRow>
            </React.Fragment>
          ) : (
            <React.Fragment key={k}>
              <TableRow>
                <StyledTableHead colSpan={5}> Elementos fornecidos pelo solo (cf. Análise de) terras </StyledTableHead>
                <StyledTableCell> {extra.elementos_forn_solo_n} </StyledTableCell>
                <StyledTableCell> {extra.elementos_forn_solo_po} </StyledTableCell>
                <StyledTableCell> {extra.elementos_forn_solo_ko} </StyledTableCell>
                <StyledTableCell> {extra.elementos_forn_solo_mgo}</StyledTableCell>
                <StyledTableCell> {extra.elementos_forn_solo_cao} </StyledTableCell>
                <StyledTableCell> {extra.elementos_forn_solo_so} </StyledTableCell>
                <StyledTableCell> {extra.elementos_forn_solo_b} </StyledTableCell>
                <StyledTableCell> {extra.elementos_forn_solo_ob} </StyledTableCell>
                <StyledTableCell rowSpan={4}>
                  {is_historico === true ? <></> :

                    <ButtonCadernos
                      mostrarBotaoEditar
                      aoClicarEditar={() => handleEdit(extra)}
                      mostrarBotaoApagar
                      aoClicarApagar={() =>
                        handleClickOpenDeleteExtra(extra)}
                    />}
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableHead colSpan={5}>
                  Elementos fornecidos pela água da rega (cf.
                  Análise de água de rega)
                </StyledTableHead>
                <StyledTableCell>{extra.elementos_forn_agua_n} </StyledTableCell>
                <StyledTableCell>  {extra.elementos_forn_agua_po} </StyledTableCell>
                <StyledTableCell> {extra.elementos_forn_agua_ko} </StyledTableCell>
                <StyledTableCell> {extra.elementos_forn_agua_mgo} </StyledTableCell>
                <StyledTableCell> {extra.elementos_forn_agua_cao} </StyledTableCell>
                <StyledTableCell> {extra.elementos_forn_agua_so} </StyledTableCell>
                <StyledTableCell> {extra.elementos_forn_agua_b} </StyledTableCell>
                <StyledTableCell> {extra.elementos_forn_agua_ob} </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableHead colSpan={5}>
                  Totais aplicados na subparcela ou na zona homogénea (kg) </StyledTableHead>
                <StyledTableCell> {extra.totais_aplicados_zona_n} </StyledTableCell>
                <StyledTableCell> {extra.totais_aplicados_zona_po} </StyledTableCell>
                <StyledTableCell> {extra.totais_aplicados_zona_ko} </StyledTableCell>
                <StyledTableCell> {extra.totais_aplicados_zona_mgo} </StyledTableCell>
                <StyledTableCell> {extra.totais_aplicados_zona_cao} </StyledTableCell>
                <StyledTableCell> {extra.totais_aplicados_zona_so}</StyledTableCell>
                <StyledTableCell> {extra.totais_aplicados_zona_b}</StyledTableCell>
                <StyledTableCell> {extra.totais_aplicados_zona_ob}</StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableHead colSpan={5}> Totais aplicados por hectare (kg/há)</StyledTableHead>
                <StyledTableCell> {extra.totais_aplicados_hectare_n}</StyledTableCell>
                <StyledTableCell> {extra.totais_aplicados_hectare_po} </StyledTableCell>
                <StyledTableCell> {extra.totais_aplicados_hectare_ko}</StyledTableCell>
                <StyledTableCell> {extra.totais_aplicados_hectare_mgo} </StyledTableCell>
                <StyledTableCell> {extra.totais_aplicados_hectare_cao}  </StyledTableCell>
                <StyledTableCell>{extra.totais_aplicados_hectare_so} </StyledTableCell>
                <StyledTableCell> {extra.totais_aplicados_hectare_b} </StyledTableCell>
                <StyledTableCell> {extra.totais_aplicados_hectare_ob} </StyledTableCell>
              </TableRow>
            </React.Fragment>
          )
        )}
      <ConfirmDialog
        open={openDeleteExtra}
        onClose={() => setOpenDeleteExtra(false)}
        onConfirm={handleDeleteExtra}
        message="Deseja eliminar o registo?"
      />
      <ConfirmDialog
        open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
        onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
        onConfirm={() => handleCloseDialog()}
        message={mensagem_tem_a_certeza_de_apagar_alteracoes}
      />
    </>
  )
}